module.exports = __webpack_public_path__ + "img/brasaoSespa.7b6ecf73.png";